export default "__VITE_ASSET__$g3I4Slp__"